import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/admin'

const getOverview = async () => {
  const response = await axios.get(`${baseURL}/analytics/overview`, getAuthHeader())
  return response.data
}

const listUsers = async (params = {}) => {
  const response = await axios.get(`${baseURL}/users`, { ...getAuthHeader(), params })
  return response.data
}

const createUser = async (payload) => {
  const response = await axios.post(`${baseURL}/users`, payload, getAuthHeader())
  return response.data
}

const updateUser = async (userId, patch) => {
  const response = await axios.patch(`${baseURL}/users/${userId}`, patch, getAuthHeader())
  return response.data
}

const deleteUser = async (userId) => {
  const response = await axios.delete(`${baseURL}/users/${userId}`, getAuthHeader())
  return response.data
}

const listCourses = async (params = {}) => {
  const response = await axios.get(`${baseURL}/courses`, { ...getAuthHeader(), params })
  return response.data
}

const createCourse = async (payload) => {
  const response = await axios.post(`${baseURL}/courses`, payload, getAuthHeader())
  return response.data
}

const updateCourse = async (courseId, patch) => {
  const response = await axios.patch(`${baseURL}/courses/${courseId}`, patch, getAuthHeader())
  return response.data
}

const deleteCourse = async (courseId) => {
  const response = await axios.delete(`${baseURL}/courses/${courseId}`, getAuthHeader())
  return response.data
}

const getCourseEnrollments = async (courseId) => {
  const response = await axios.get(`${baseURL}/courses/${courseId}/enrollments`, getAuthHeader())
  return response.data
}

const addCourseEnrollment = async (courseId, payload) => {
  const response = await axios.post(`${baseURL}/courses/${courseId}/enrollments`, payload, getAuthHeader())
  return response.data
}

const updateCourseEnrollment = async (courseId, enrollmentId, patch) => {
  const response = await axios.patch(
    `${baseURL}/courses/${courseId}/enrollments/${enrollmentId}`,
    patch,
    getAuthHeader()
  )
  return response.data
}

const deleteCourseEnrollment = async (courseId, enrollmentId) => {
  const response = await axios.delete(
    `${baseURL}/courses/${courseId}/enrollments/${enrollmentId}`,
    getAuthHeader()
  )
  return response.data
}

const getEmailRecipients = async (params = {}) => {
  const response = await axios.get(`${baseURL}/email/recipients`, {
    ...getAuthHeader(),
    params: { target: params.target, sampleSize: params.sampleSize }
  })
  return response.data
}

const broadcastEmail = async (payload) => {
  const response = await axios.post(`${baseURL}/email/broadcast`, payload, getAuthHeader())
  return response.data
}

const adminService = {
  getOverview,
  listUsers,
  createUser,
  updateUser,
  deleteUser,
  listCourses,
  createCourse,
  updateCourse,
  deleteCourse,
  getCourseEnrollments,
  addCourseEnrollment,
  updateCourseEnrollment,
  deleteCourseEnrollment,
  getEmailRecipients,
  broadcastEmail
}

export default adminService

